module.exports = __webpack_public_path__ + "img/Withdrawal_Code_Fiat_manual.2d010c32.png";